import React, { useEffect, useState } from "react";
import adminService from "../../services/adminService";

// ✅ Backend base url (fallback 4000)
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "https://nouzhaback-theta.vercel.app").replace(/\/$/, "");

const pick = (obj, paths, fallback = null) => {
  for (const p of paths) {
    const v = p.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), obj);
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return fallback;
};

const AssignVisiteModal = ({ reservation, onClose, onAssigned }) => {
  const reservationId = reservation?._id;

  const [visites, setVisites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVisiteId, setSelectedVisiteId] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        const rawVille = pick(
          reservation,
          ["ville", "destination", "details.ville", "client.ville", "location"],
          ""
        );

        const neededVille =
          typeof rawVille === "string"
            ? rawVille
            : (rawVille?.name || rawVille?.label || rawVille?.value || "");

        const ville = (neededVille || "").trim();

        if (!ville) {
          setVisites([]);
          return;
        }

        const res = await adminService.getVisitesByVille(ville);
        const list = res?.data?.data ?? res?.data ?? res ?? [];
        setVisites(Array.isArray(list) ? list : []);
      } catch (e) {
        console.error(e);
        setVisites([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [reservationId, reservation]);

  const assign = async () => {
    if (!selectedVisiteId) return alert("Sélectionne une visite");

    try {
      await adminService.assignVisiteToReservation(reservationId, selectedVisiteId);
      alert("Visite assignée ✅");
      await onAssigned?.();
    } catch (e) {
      console.error(e);
      alert(e?.message || "Erreur lors de l'assignation");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[85] flex items-center justify-center p-4 pt-20 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl overflow-hidden">
        <div className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-lg font-bold">Assigner une visite guidée</h3>
              <p className="text-xs text-white/90">Réservation ID: {reservationId || "—"}</p>
            </div>
            <button onClick={onClose} className="text-white hover:text-slate-200">
              ✖
            </button>
          </div>
        </div>

        <div className="p-6 max-h-[70vh] overflow-y-auto">
          {loading ? (
            <div className="p-6 text-center text-slate-600">Chargement des visites...</div>
          ) : visites.length === 0 ? (
            <div className="p-6 text-center text-slate-600">Aucune visite disponible.</div>
          ) : (
            <div className="space-y-3">
              {visites.map((v) => {
                const titre = pick(v, ["titre"], "Visite");
                const ville = pick(v, ["ville"], "—");
                const prix = pick(v, ["prix"], "—");
                const date = pick(v, ["date"], null);
                const image = pick(v, ["image"], "");

                return (
                  <label
                    key={v._id}
                    className={`flex items-center gap-4 p-4 rounded-xl border cursor-pointer transition ${selectedVisiteId === v._id
                        ? "border-orange-500 bg-orange-50"
                        : "border-slate-200 hover:bg-slate-50"
                      }`}
                  >
                    <input
                      type="radio"
                      name="visite"
                      checked={selectedVisiteId === v._id}
                      onChange={() => setSelectedVisiteId(v._id)}
                      className="h-4 w-4 accent-orange-600"
                    />

                    <div className="flex-1">
                      <div className="font-bold text-slate-900">{titre}</div>
                      <div className="text-sm text-slate-600">
                        {ville} • {prix !== "—" ? `${prix} MAD` : "prix —"} •{" "}
                        {date ? new Date(date).toLocaleDateString("fr-FR") : "date —"}
                      </div>
                      <div className="text-xs text-slate-500 mt-1">ID: {v._id}</div>
                    </div>

                    {image && (
                      <img
                        src={image.startsWith("http") ? image : `${API_BASE}${image}`}
                        alt="visite"
                        className="w-24 h-16 object-cover rounded-lg border border-slate-200"
                        onError={(e) => (e.currentTarget.style.display = "none")}
                      />
                    )}
                  </label>
                );
              })}
            </div>
          )}
        </div>

        <div className="bg-slate-50 px-6 py-4 flex flex-col sm:flex-row gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-100 transition-colors"
          >
            Fermer
          </button>
          <button
            onClick={assign}
            disabled={!selectedVisiteId}
            className="px-5 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors disabled:opacity-50"
          >
            ✅ Assigner cette visite
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignVisiteModal;
